export const SERVICE_ACCESS_LIST = [
  "dashboard",
  "flows",
  "viewer/forge",
  "viewer/maps",
  "planning",
  "events",
  "risks",
  "resources",
  "settings",
] as const;

export type ServiceAccess = typeof SERVICE_ACCESS_LIST[number];

export const API_ACCESS_LIST = [
  "dashboard",
  "chart",
  "flow",
  "model",
  "planning",
  "task",
  "metric",
  "tag",
  "tracker",
  "unit",
  "zone",
] as const;

export type ApiAccess = typeof API_ACCESS_LIST[number];

export const ACCESS_TYPE_LIST = ["read", "write", "admin"] as const;
export type ReadWriteAdminType = typeof ACCESS_TYPE_LIST[number];

export interface Access {
  id: string;
  author: string;
  name: string;
  services: Record<ServiceAccess, boolean>;
  api: Record<ApiAccess, Record<ReadWriteAdminType, boolean>>;

  // optionnel, plus typé
  labelProjects?: string[];
  adminAccess?: boolean;
}

export const defaultAccess: Access = {
  id: "",
  author: "",
  name: "",
  services: SERVICE_ACCESS_LIST.reduce((acc, service) => {
    acc[service] = false;
    return acc;
  }, {} as Record<ServiceAccess, boolean>),

  api: API_ACCESS_LIST.reduce((acc, api) => {
    acc[api] = ACCESS_TYPE_LIST.reduce((typeAcc, type) => {
      typeAcc[type] = false;
      return typeAcc;
    }, {} as Record<ReadWriteAdminType, boolean>);
    return acc;
  }, {} as Record<ApiAccess, Record<ReadWriteAdminType, boolean>>),
  labelProjects: [],
};